/* eslint-disable import/prefer-default-export */
export const productOptions = new Map([
  ['savings',
    [
      {
        imgSrc: 'https://d1ic4altzx8ueg.cloudfront.net/finder-au/wp-uploads/2013/01/habits2.png', // null || string
        listElements: [
          {
            label: 'Monto mínimo',
            value: 50,
            definition: 'Definicion de monto mínimo',
          }, 
          {
            label: 'Plazo forzoso',
            value: 40,
            definition: 'Este es el plazo forzoso',
          },
          {
            label: 'Tasa de retorno',
            value: 2,
            definition: 'Esta es la tasa de retorno',
          },
        ],
        buttons: {
          moreInfo: 'More info',
          callToAction: 'Adquirir ahora',
        },
      },
    ],
  ],
]);
